<!--
 * @Description: 特色功能介绍
 * @Author: F-Stone
 * @LastEditTime: 2023-10-30 18:31:44
-->
<template>
    <div :class="$style['m-banner']">
        <div class="m-container" :class="$style['m-container']">
            <div :class="$style['container-inner']">
                <div :class="$style['module-head']" class="flex justify-center">
                    <div :class="$style['module-info']">
                        <h2 ref="titleText" :class="$style['module-title']">
                            <!-- <div :class="$style['line-1']">
                                <span :class="$style['text']">
                                    Web 3.0 premier
                                </span>
                                <i :class="$style['cursor']"></i>
                            </div>
                            <div :class="$style['line-2']">
                                <span :class="$style['text']">
                                    crypto trading &
                                </span>
                                <i :class="$style['cursor']"></i>
                            </div>
                            <div :class="$style['line-3']">
                                <span :class="$style['text']">
                                    DAO brand.
                                </span>
                                <i :class="$style['cursor']"></i>
                            </div> -->
                            <div :class="$style['line-1']">
                                <span :class="$style['text']">
                                    <!-- First Web3 Crypto Exchange -->
                                    {{$t('400000')}}
                                </span>
                                <i :class="$style['cursor']"></i>
                            </div>
                        </h2>
                        <h3 ref="subtitle" :class="$style['module-subtitle']">
                            <span class="text">
                                <!-- Join us to create a financial world -->
                                {{$t('400001')}}
                            </span>
                        </h3>
                        <div ref="btnGroup" :class="$style['module-btn-group']" class="flex justify-center">
                            <button v-if="!token" :class="$style['btn--register']" class="grid grid-flow-col-dense justify-center items-center" @click="$router.push({path:'/register'})">
                                <span class="text">
                                    <!-- Register now -->
                                    {{$t('300252')}}
                                </span>
                                <UeIcon name="long-arrow-right" :class="[$style['ic'], { mirrorRotateLevel: isDirection }]" />
                            </button>
                            <button v-else :class="$style['btn--register']" class="grid grid-flow-col-dense justify-center items-center" @click="$router.push({path:'/download'})">
                                <span class="text">
                                    <!-- 立即下载 -->
                                    {{$t('300345')}}
                                </span>
                                <UeIcon name="long-arrow-right" :class="[$style['ic'], { mirrorRotateLevel: isDirection }]" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {}
    },
    computed: {
        ...mapGetters(['isDirection', 'language','token']),
    },
}
</script>
<style lang="scss" module>
@import '../../../assets/uemo-scss/scss/abstracts/_mixins.scss';
@import '../../../assets/uemo-scss/scss/abstracts/_functions.scss';
@keyframes caret {
    50% {
        border-color: transparent;
    }
}
.m-banner {
    position: relative;

    padding: 200px 0 120px;
    .m-bg {
        position: absolute;
        bottom: -568px;
        left: calc(50% - 960px);

        width: 1920px;
        video {
            mix-blend-mode: lighten;
        }
    }
    .m-container {
        position: relative;
        z-index: var(--g--z-index);
    }
    .module-title {
        // font-size: 76px;
        // font-size: 10.133vw;
        font-size: 9.9vw;
        font-weight: 800;
        line-height: 120%;

        max-width: 750px;
        color: #ffffff;
        text-align: center;
        letter-spacing: -3.04px;
        .line-1,
        .line-2,
        .line-3 {
            &::after {
                display: inline-block;

                height: 1em;

                content: '';
                animation: caret 1s steps(1) infinite;
                vertical-align: middle;

                opacity: 0;
                border-right: 0.1em solid;
            }
        }
    }
    .module-subtitle {
        font-size: 24px;
        font-weight: 500;
        font-style: normal;
        line-height: 140%;

        margin-top: 20px;

        text-align: center;

        // color: color(var(--g--color-font--default), 0.6);
        color: #ffffff;
        span {
            color: rgba(255, 255, 255, 0.6) !important;
            font-size: 3.2vw !important;
        }
    }
    .module-btn-group {
        margin-top: 50px;
        .btn--register {
            font-size: 24px;
            font-weight: 500;
            line-height: 160%; /* 22.4px */

            padding: 24px 46px;

            border: 3px solid currentColor;
            border-radius: 100px;
            // background: rgb(1 3 20 / 0.1);
            // box-shadow: 0 7.0922px 88.65249px 0 rgb(255 255 255 / 0.2);
            // background: rgba(1, 3 ,20 , 0.1);
            // box-shadow: 0 7.0922px 88.65249px 0 rgba(255 ,255 ,255 , 0.2);
            gap: 16px;
            color: #ffffff;
            border-color: #ffffff;
            background-color: #17171a;
            .ic {
                font-size: 30px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/compontents/newHome/index/BannerModule.vue